import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Section, Reveal } from './Section';
const rows = [{
  situation: 'No sabés cuánto arriesgar',
  without: 'Entrás a ciegas',
  with: 'Calculadora de riesgo lista'
}, {
  situation: 'Encontrás una estrategia online',
  without: 'No sabés si funciona',
  with: 'Backtesting paso a paso'
}, {
  situation: 'Dudás si el método funciona',
  without: 'Confiás sin evidencia',
  with: '5 casos reales analizados'
}, {
  situation: 'Querés aprender pero no podés pagar $500 USD',
  without: 'Quedás afuera',
  with: 'Mismo método, sin barrera'
}];
export function ComparisonTable() {
  return <Section className="bg-ink-950" data-id="element-32" data-mp="38djes5yy8v4t">
      <Reveal data-id="element-33" data-mp="3dd5rmeav89d3">
        <h2 className="font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl lg:text-4xl" data-id="element-34" data-mp="3dcmfxfbt6h7i">
          Con y sin Capital Consciente
        </h2>
      </Reveal>

      <Reveal delay={0.08} data-id="element-35" data-mp="21xpgdbi009lw">
        <div className="mt-8 overflow-hidden rounded-2xl border border-white/10" data-id="element-36" data-mp="21z0gn1c8iz89">
          {/* header */}
          <div className="grid grid-cols-3 border-b border-white/10 bg-ink-850 text-xs font-semibold uppercase tracking-wide text-gray-400 sm:text-sm" data-id="element-37" data-mp="2dy6xlq73sjhv">
            <div className="p-3 sm:p-4" data-id="element-38" data-mp="2nvlets0upcb8">Tu situación</div>
            <div className="border-l border-white/10 p-3 sm:p-4" data-id="element-39" data-mp="2nx68lffccr81">Sin CC</div>
            <div className="border-l border-white/10 bg-brand-soft p-3 text-brand sm:p-4" data-id="element-40" data-mp="2ivgufqwtnxfq">
              Con CC
            </div>
          </div>

          {rows.map((r, i) => <div key={r.situation} className={`grid grid-cols-3 text-sm ${i % 2 === 0 ? 'bg-ink-900' : 'bg-ink-950'}`} data-id="element-41" data-mp="2suxzq785w9b6" data-mpi={i}>
              <div className="p-3 font-medium text-gray-200 sm:p-4" data-id="element-42" data-mp="36mcj4f5zecir">
                {r.situation}
              </div>
              <div className="flex items-start gap-2 border-l border-white/10 p-3 text-gray-400 sm:p-4" data-id="element-43" data-mp="31ob1lyo7el9e">
                <XIcon className="mt-0.5 h-4 w-4 flex-none text-red-400/70" data-id="element-44" data-mp="3gksbsmknptud" />
                <span data-id="element-45" data-mp="3blyzgxh3w8vs">{r.without}</span>
              </div>
              <div className="flex items-start gap-2 border-l border-white/10 bg-brand-soft/40 p-3 text-gray-100 sm:p-4" data-id="element-46" data-mp="3bjcsp021hxem">
                <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand" data-id="element-47" data-mp="3nmxhl2f5jfiw" />
                <span data-id="element-48" data-mp="3smjwdgamp3tt">{r.with}</span>
              </div>
            </div>)}
        </div>
      </Reveal>
    </Section>;
}